var map = {
	"./bedok-back.png": 48,
	"./bedok.png": 122,
	"./bg-cloud.png": 123,
	"./bg.png": 124,
	"./closeIcon.png": 30,
	"./defence.png": 125,
	"./economy.png": 126,
	"./edb-back.png": 49,
	"./edb.png": 127,
	"./environment.png": 128,
	"./hdb-back.png": 50,
	"./hdb.png": 129,
	"./housing.png": 130,
	"./limchukang-back.png": 51,
	"./limchukang.png": 131,
	"./limchukang2.png": 132,
	"./mandai-back.png": 52,
	"./mandai.png": 133,
	"./mindef-back.png": 53,
	"./mindef.png": 134,
	"./museum-back.png": 54,
	"./museum.png": 135,
	"./npb-back.png": 55,
	"./npb.png": 136,
	"./onlineIcon.png": 31,
	"./pasirris-back.png": 56,
	"./pasirris.png": 137,
	"./punggol-back.png": 57,
	"./punggol.png": 138,
	"./reserve.png": 139,
	"./seletar-back.png": 58,
	"./seletar.png": 140,
	"./sembawang-back.png": 59,
	"./sembawang.png": 141,
	"./stb-back.png": 60,
	"./stb.png": 142,
	"./tourism.png": 143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11;